var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"background-block",style:({ height: _vm.height, backgroundColor: _vm.blockInfo.color })},[(_vm.blockInfo.media)?_c('CommonMedia',{attrs:{"media":_vm.blockInfo.media,"video-loop":true}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }